// extracted by mini-css-extract-plugin
export default {"payment":"Payment_payment__h70R-","base":"Payment_base__cMz3d","header":"Payment_header__Qasim","controls":"Payment_controls__ZL+Up"};